module.exports = __webpack_public_path__ + "img/LSBBSceno.9313cc55.png";